/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {StartPasskeyVerificationRequest} from '@cash-web/protos/squareup/cash/janus/api/WebAuthn.pb'
import {StartPasskeyVerificationResponse} from '@cash-web/protos/squareup/cash/janus/api/WebAuthn.pb'


export const startPasskeyVerification = (request: StartPasskeyVerificationRequest, options?: CashRequestOptions) => post<StartPasskeyVerificationRequest, StartPasskeyVerificationResponse>("/2.0/cash/start-passkey-verification", request, {...options, rejectOnError: true })